(function () {
  function bindTopMenuLinks(root) {
    (root || document).querySelectorAll('.header__menu-item-link').forEach(function (link) {
      if (link.dataset.topMenuLinkBound === 'true') return;
      link.dataset.topMenuLinkBound = 'true';

      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href === '#') {
          event.preventDefault();
          return;
        }
        event.stopPropagation();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindTopMenuLinks();
    });
  } else {
    bindTopMenuLinks();
  }

  document.addEventListener('shopify:section:load', function (event) {
    bindTopMenuLinks(event.target);
  });
})();
